// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // api_endpoint: 'http://167.71.226.114:2512/heartcare/',
  // api_endpoint: 'http://167.71.226.114:2510/heartcare/',
  //dev
  // api_endpoint: 'http://143.110.253.49/admin-api/heartcare/',
  // react_origin: 'http://143.110.253.49',
  // react_base: 'http://143.110.253.49/screening',
  //uat

  api_endpoint: 'https://heartcareadminuat.thelattice.in/webservices/heartcare/',
  react_origin: 'https://heartcareadminuat.thelattice.in',
  react_base: 'https://heartcareadminuat.thelattice.in/screening',

  //local
  // api_endpoint: 'http://143.110.253.49/admin-api/heartcare/',
  // react_origin: 'http://localhost:5173',
  // react_base: 'http://localhost:5173/screening',
  //prod
  // api_endpoint: ' https://adminhc.thelattice.in/webservices/heartcare/',
  // react_origin: 'https://admin-heartcare.gov.vu',
  // react_base: 'https://admin-heartcare.gov.vu/screening',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
